export const useLazyComponent = <T>(
  loader: () => PromiseLike<Component<T>>
) => {
  const _component = shallowRef<Component<T>>((_: T) => h('div'));
  const component = computed(() => {
    loadImmediately();
    return _component.value;
  });

  const initialized = ref(false);
  const loadImmediately = async () => {
    if (initialized.value) return;
    _component.value = await loader();
    initialized.value = true;
  };

  return { component, loadImmediately };
};
